<script lang="ts" setup>
const { t } = useI18n()
const localePath = useLocalePath()
const route = useRoute()

const navigation = computed((): LayoutHeaderNavigationGroups => {
  return [
    [
      {
        active: route.path === localePath('settings'),
        icon: getIcon('dashboard'),
        label: t('navigation.settings.dashboard'),
        to: localePath('settings'),
      },
    ],
    [
      {
        icon: getIcon('subscription'),
        label: t('navigation.settings.subscription'),
        to: localePath('settings-subscription'),
      },
      {
        icon: getIcon('team'),
        label: t('navigation.settings.team'),
        to: localePath('settings-team'),
      },
      {
        icon: getIcon('profile'),
        label: t('navigation.settings.profile'),
        to: localePath('settings-profile'),
      },
      {
        icon: getIcon('webhook'),
        label: t('navigation.settings.webhooks'),
        to: localePath('settings-webhooks'),
      },
    ],
  ]
})

definePageMeta({ hasSubnav: true })
</script>

<template>
  <LayoutHeaderNavigation
    key="settings"
    :navigation="navigation"
  />

  <UContainer class="py-20">
    <NuxtPage />
  </UContainer>
</template>
